import { type RefObject, useEffect, useRef } from 'react';
import {
  type MediaProgress,
  observeMediaProgress,
} from '../utils/mediaProgress';

export function useMediaProgress(
  mediaRef: RefObject<HTMLMediaElement | null> | undefined,
  onProgress: (progress: MediaProgress) => void,
  enabled = true,
  source = '',
) {
  const callback = useRef(onProgress);
  callback.current = onProgress;

  useEffect(() => {
    const media = mediaRef?.current;
    if (!enabled || !media) return;
    return observeMediaProgress(media, (progress) =>
      callback.current(progress),
    );
  }, [mediaRef, enabled, source]);
}
